import React, { useState } from 'react';

/** Copies `text` to the clipboard and says so for a moment. */
export function CopyButton({ text, label }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      aria-label={label}
      onClick={() =>
        navigator.clipboard?.writeText(text).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        })
      }
      className="shrink-0 rounded-full px-2 text-sm text-dl-accent ring-1 ring-dl-border hover:bg-dl-tint"
    >
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
}
